export const followUpOptions = {
  0: {
    label: '未分配',
    value: 0
  },
  1: {
    label: '已分配',
    value: 1
  },
  2: {
    label: '跟进中',
    value: 2
  },
  3: {
    label: '有意向',
    value: 3
  },
  4: {
    label: '预约上门',
    value: 4
  },
  5: {
    label: '已上门',
    value: 5
  },
  6: {
    label: '已签约',
    value: 6
  },
  7: {
    label: '已付诚意金',
    value: 7
  },
  8: {
    label: '已交付',
    value: 8
  },
  9: {
    label: '进件完成',
    value: 9
  }
}

export const startOptions = {

  0: {
    label: '0星',
    value: '0'
  },
  1: {
    label: '1星',
    value: '1'
  },
  2: {
    label: '2星',
    value: '2'
  },
  3: {
    label: '3星',
    value: '3'
  },
  4: {
    label: '4星',
    value: '4'
  },
  5: {
    label: '5星',
    value: '5'
  }
}
export const passOptions = {
  0: {
    label: '新客户未联系',
    value: 0
  },
  1: {
    label: '未接',
    value: 1
  },
  2: {
    label: '关机',
    value: 2
  },
  3: {
    label: '拒接',
    value: 3
  },
  4: {
    label: '通话中',
    value: 4
  },
  5: {
    label: '外地',
    value: 5
  },
  6: {
    label: '已接通',
    value: 6
  }
}
export const effectiveOptions = [
  {
    label: '无效',
    value: 0
  },
  {
    label: '有效',
    value: 1
  }
]
export const starOptions = {
  '1星': {
    color: '#438BFF',
    background: 'rgba(67,139,255,0.1)'
  },
  '2星': {
    color: '#F3C347',
    background: 'rgba(243,195,71,0.1)'
  },
  '3星': {
    color: '#8E30FF',
    background: 'rgba(142,48,255,0.1)'
  },
  '4星': {
    color: '#4A50DB',
    background: 'rgba(74, 80, 219, 0.1)'
  },
  '5星': {
    color: '#FE9D22',
    background: 'rgba(254,157,34,0.1)'
  },
  '重要客户': {
    color: '#F35547',
    background: 'rgba(243,85,71,0.1)'
  },
  '种草客户': {
    color: '#28D890',
    background: 'rgba(40,216,144,0.1)'
  },
  '捣乱': {
    color: '#E230FF',
    background: 'rgba(226,48,255,0.1)'
  },
  '未接通': {
    color: '#3FBFD9',
    background: 'rgba(63,191,217,0.1)'
  },
}